import React from 'react'
import withBulkAction from '../with-bulk-action/with-bulk-action'
import Button from 'pobble-components/dist/button'
import DropMenu from 'pobble-components/dist/drop-menu'
import EllipsIcon from 'react-icons/lib/fa/ellipsis-h'
import injectSheet from 'react-jss'
import styles from './action-button.styles'
import PropTypes from 'prop-types'

const BulkActionButton = ({
  classes,
  placement,
  bulkSelected,
  bulkSelectedList,
  children
}) => (
  <DropMenu
    placement={placement}
    button={({ ref, togglePopover }) => (
      <Button
        disabled={!bulkSelectedList.length}
        tall
        nodeRef={ref}
        action={togglePopover}>
        <EllipsIcon className={classes.icon} />
        Action
      </Button>
    )}>
    {dropMenuProps =>
      children({ ...dropMenuProps, bulkSelected, bulkSelectedList })
    }
  </DropMenu>
)

BulkActionButton.propTypes = {
  /** Placement of drop menu, see DropMenu component for reference */
  placement: PropTypes.string,
  /** Render prop function that receives all drop menu props plus bulk selected props */
  children: PropTypes.func.isRequired
}

export default withBulkAction(injectSheet(styles)(BulkActionButton))
